import { render, staticRenderFns } from "./MassRunQueue.vue?vue&type=template&id=1b96f4a0&"
import script from "./MassRunQueue.vue?vue&type=script&lang=js&"
export * from "./MassRunQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports